import { render, staticRenderFns } from "./MarketplaceProvidersComponet.vue?vue&type=template&id=093d1025&scoped=true"
import script from "./MarketplaceProvidersComponet.vue?vue&type=script&lang=js"
export * from "./MarketplaceProvidersComponet.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProvidersComponet.vue?vue&type=style&index=0&id=093d1025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d1025",
  null
  
)

export default component.exports